/* Cubitt: animaciones de las secciones A+ de la ficha (diseño "+A - Terra").
   - Aparición al llegar a cada elemento ([data-aplus-reveal]): el CSS solo los oculta cuando este archivo marca la
     sección con .is-aplus-ready, así que sin JS o con "reducir movimiento" todo se ve quieto.
   - Los elementos que entran juntos aparecen escalonados (--aplus-i, en orden del documento).
   - Parallax suave de las fotos ([data-aplus-parallax]): solo se calcula mientras la foto está en pantalla.
   - El "Sleep Score" cuenta desde 0 cuando aparece su tarjeta. */

const SECTION_SELECTOR = '.cubitt-aplus[data-aplus-animate]';
const MAX_STAGGER = 12;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const parallaxItems = new Set();
let parallaxQueued = false;

function updateParallax() {
  parallaxQueued = false;
  const viewport = window.innerHeight;

  parallaxItems.forEach((item) => {
    const rect = item.getBoundingClientRect();
    /* -1 cuando la foto entra por abajo, 0 en el centro de la pantalla, 1 cuando sale por arriba. */
    const progress = (viewport / 2 - (rect.top + rect.height / 2)) / (viewport / 2 + rect.height / 2);
    item.style.setProperty('--aplus-px', Math.max(-1, Math.min(1, progress)).toFixed(3));
  });
}

function queueParallax() {
  if (parallaxQueued || !parallaxItems.size) return;
  parallaxQueued = true;
  requestAnimationFrame(updateParallax);
}

const parallaxObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) parallaxItems.add(entry.target);
    else parallaxItems.delete(entry.target);
  });
  queueParallax();
});

window.addEventListener('scroll', queueParallax, { passive: true });
window.addEventListener('resize', queueParallax, { passive: true });

function speedOf(element) {
  return parseFloat(getComputedStyle(element).getPropertyValue('--aplus-speed')) || 1;
}

function countScore(card, delay) {
  const value = card.querySelector('.cubitt-aplus-card__score-value');
  const text = value?.textContent.trim() || '';
  if (!/^\d+$/.test(text)) return;

  const target = parseInt(text, 10);
  const duration = 1400 * speedOf(card);
  value.textContent = '0';

  setTimeout(() => {
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      value.textContent = String(Math.round(target * (1 - Math.pow(1 - t, 3))));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, delay);
}

const byDocumentOrder = (a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries
      .filter((entry) => entry.isIntersecting)
      .map((entry) => entry.target)
      .sort(byDocumentOrder)
      .forEach((element, index) => {
        const order = Math.min(index, MAX_STAGGER);
        element.style.setProperty('--aplus-i', order);
        element.classList.add('is-revealed');
        revealObserver.unobserve(element);

        if (element.classList.contains('cubitt-aplus-card')) {
          countScore(element, (300 + order * 110) * speedOf(element));
        }
      });
  },
  { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
);

function init(section) {
  if (reducedMotion.matches || section.classList.contains('is-aplus-ready')) return;

  section.classList.add('is-aplus-ready');
  section.querySelectorAll('[data-aplus-reveal]').forEach((element) => revealObserver.observe(element));
  section.querySelectorAll('[data-aplus-parallax]').forEach((element) => parallaxObserver.observe(element));
}

function teardown(container) {
  container.querySelectorAll('[data-aplus-reveal]').forEach((element) => revealObserver.unobserve(element));
  container.querySelectorAll('[data-aplus-parallax]').forEach((element) => {
    parallaxObserver.unobserve(element);
    parallaxItems.delete(element);
  });
}

document.querySelectorAll(SECTION_SELECTOR).forEach(init);

/* Editor del tema: al cambiar un setting la sección se vuelve a pintar. */
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll(SECTION_SELECTOR).forEach(init));
document.addEventListener('shopify:section:unload', (event) => teardown(event.target));
